import http from '@/utils/request';

export const fetchDynamic = (dynamicId: string, userId: string) => {
  return http.get<BaseResponse<Dynamic.DynamicData>>(
    `/oapi/dynamics/${dynamicId}/${userId}.json`,
  );
};

export const fetchSubject = (subjectId: string) => {
  return http.get<BaseResponse<Dynamic.DynamicSubjectDetail>>(
    `/oapi/subjects/${subjectId}.json`,
  );
};

export const fetchSubjectDynamics = (
  subjectId: string,
  userId: string,
  pageNum = 1,
  pageSize = 20,
) => {
  return http.get<BaseResponse<Dynamic.DynamicSubjectDynamic>>(
    `/oapi/subjects/${subjectId}/dynamics/${userId}/${pageNum - 1}/${pageSize}.json`,
  );
};

export const fetchUserInfo = (uuid: string) => {
  const { VITE_BASE_DOMAIN, DEV } = import.meta.env;
  return http.get<BaseResponse<Dynamic.UserInfo>>(
    `/ucs/api/v1/private/userFollowInfo-basic`,
    {
      baseURL: DEV ? '/' : VITE_BASE_DOMAIN,
      params: {
        userId: uuid,
        channelId: import.meta.env.VITE_SITE_ID,
      },
    },
  );
};

export const fetchUserDynamics = (
  uuid: string,
  userId: string,
  pageNum = 1,
  pageSize = 10,
) => {
  return http.get<BaseResponse<Dynamic.UserDynamic>>(
    `/oapi/users/${uuid}/dynamics/${userId}/${pageNum - 1}/${pageSize}.json`,
  );
};

export const fetchDynamicComments = (dynamicsId: string, pageNum = 1, pageSize = 20) => {
  return http.get<BaseResponse<Dynamic.DynamicComment>>(
    `/oapi/dynamics/${dynamicsId}/comments/undefined/${pageNum - 1}/${pageSize}`,
  );
};
